import type { BasketBooking, BookingItem } from 'types/booking';
import moment from './dayjs';
import { formatStartAndEndTimes } from './time';

// The subset of a just-created booking that the GTM addToCart payload is built
// from.
type GTMBookingItem = Pick<
  BookingItem,
  'id' | 'startTime' | 'endTime' | 'totalCost' | 'space'
>;

interface GTMBooking
  extends Pick<BasketBooking, 'id' | 'clientService' | 'venue' | 'recurring'> {
  bookingItems: GTMBookingItem[];
}

export const renderBookingsToGTM = (bookings: GTMBooking[]) => {
  return bookings.flatMap(booking => {
    const bookingId = booking.id;
    const clientServiceName = booking.clientService.name;
    const venueName = booking.venue.name;
    const isRecurring = booking.recurring;

    return booking.bookingItems.map(bookingItem => {
      const quantity = moment
        .duration(
          moment(bookingItem.endTime).diff(moment(bookingItem.startTime))
        )
        .asHours();

      return {
        id: bookingItem.id,
        name: `${venueName} - ${bookingItem.space.name}`,
        sku: bookingItem.space.id,
        // Costs are decimal strings on the wire.
        price: Number(bookingItem.totalCost) / quantity,
        quantity,
        dimension1: bookingId,
        dimension2: clientServiceName,
        dimension3: isRecurring,
        metric1: formatStartAndEndTimes(
          bookingItem.startTime,
          bookingItem.endTime
        ),
      };
    });
  });
};
